import React, { ReactNode, useEffect, useState } from 'react';
import {
  Box,
  Flex,
  HStack,
  VStack,
  useColorModeValue,
  Link,
  Text,
  FlexProps,
} from '@chakra-ui/react';
import {
  StarIcon
} from '@chakra-ui/icons';
import { useNavigate } from 'react-router-dom';

const NAVBAR_HEIGHT = '12vh'
const ADSPACE_WIDTH = '10%'
const CONTENT_WIDTH = '79%'
const ADD_HEIGHT = '76vH'

function AppShell({children, isAuthed}: {children: ReactNode, isAuthed: boolean;}) {
  const [width, setWidth] = useState<number>(window.innerWidth);

  function handleWindowSizeChange() {
      setWidth(window.innerWidth);
  }

  useEffect(() => {
      window.addEventListener('resize', handleWindowSizeChange);
      return () => {
          window.removeEventListener('resize', handleWindowSizeChange);
      }
  }, []);

  const isMobile = width <= 768;
  
  
  return (
    <>
      {!isMobile && <Box minH='100vh'>
        <Header mobile={isMobile} isAuthed={isAuthed}/>
        <HStack alignItems={'start'}>
          <Box backgroundColor={'grey'} top={NAVBAR_HEIGHT} position='fixed' minW={ADSPACE_WIDTH} maxW={ADSPACE_WIDTH} minH={ADD_HEIGHT}>
            <Text fontSize={'48'}>
              AD GOES HERE
            </Text>
          </Box>
          <Box backgroundColor={'grey'} top={NAVBAR_HEIGHT} minW={ADSPACE_WIDTH} maxW={ADSPACE_WIDTH} minH={ADD_HEIGHT}/>
          <Box minW={CONTENT_WIDTH} maxW={CONTENT_WIDTH}>
            {children}
          </Box>
          <Box backgroundColor={'grey'} top={NAVBAR_HEIGHT} position='fixed' right='0' minW={ADSPACE_WIDTH} maxW={ADSPACE_WIDTH} minH={ADD_HEIGHT}>
            <Text fontSize={'48'}>
              AD GOES HERE
            </Text>
          </Box>
          <Box backgroundColor={'grey'} top={NAVBAR_HEIGHT} minW={ADSPACE_WIDTH} maxW={ADSPACE_WIDTH} minH={ADD_HEIGHT}>
            AD GOES HERE
          </Box>
        </HStack>
        <Footer/>
      </Box>}
      {isMobile && <Box minH='100vh'>
        <Header mobile={isMobile} isAuthed={isAuthed}/>
        <HStack alignItems={'start'}>
          <Box backgroundColor={'white'} top={NAVBAR_HEIGHT} position='fixed' minW={"10px"} maxW={"10px"} minH={ADD_HEIGHT}>
          </Box>
          <Box backgroundColor={'white'} top={NAVBAR_HEIGHT} minW={"10px"} maxW={"10px"} minH={ADD_HEIGHT}/>
          <Box minW={"79%"} maxW={"79%"}>
              {children}
          </Box>
          <Box backgroundColor={'white'} top={NAVBAR_HEIGHT} position='fixed' right='0' minW={"10px"} maxW={"10px"} minH={ADD_HEIGHT}>
          </Box>
          <Box backgroundColor={'white'} top={NAVBAR_HEIGHT} minW={"10px"} maxW={"10px"} minH={ADD_HEIGHT}>
          </Box>
        </HStack>
        <Footer/>
      </Box>}
    </>
  );
}

interface HeaderProps extends FlexProps {
  mobile: boolean
  isAuthed: boolean;
}

const Header = ({mobile, isAuthed}: HeaderProps) => {
  const navigate = useNavigate(); 
  const routeChange = () =>{ 
    const path = `/`; 
    navigate(path);
  }

  return (
    <HStack
      zIndex={1000}
      style={{zIndex:999}}
      top='0'
      position='sticky'
      // width='100vw'
      height={NAVBAR_HEIGHT}
      alignItems='start'
      bg={useColorModeValue('white', 'gray.900')}
      borderBottomWidth="1px"
      borderBottomColor={useColorModeValue('gray.200', 'gray.700')}>
      <Box
        px={{ base: 4, md: 4 }}
        // width='100%'
        height={NAVBAR_HEIGHT}
        width='80vw'>
        <Link onClick={() => {routeChange()}} fontFamily='cursive' fontSize={mobile ? '3xl' : '5xl'}>
          I Just Be Online
        </Link>
      </Box>
      {isAuthed && 
        <VStack
          p='4'
          // width='100%'
          height={NAVBAR_HEIGHT}
          width='20vw'
          alignItems={"end"}>
          <StarIcon fontSize={mobile ? '3xl' : '5xl'}/>
        </VStack>
      }
    </HStack>
  )
}

const Footer = () => {
  return (
    <HStack
      style={{zIndex:999}}
      // ml={{ base: 0, md: 60 }}
      // px={{ base: 4, md: 4 }}
      width="100vw"
      height={NAVBAR_HEIGHT}
      alignItems="center"
      bg={useColorModeValue('black', 'gray.900')}
      borderBottomWidth="1px">
      <Flex
        // ml={{ base: 0, md: 60 }}
        px={{ base: 4, md: 4 }}
        width='100%'
        height={NAVBAR_HEIGHT}
        alignItems="center"
        justifyContent="center"
        color={useColorModeValue('white', 'gray.900')}
        borderWidth="1px"
        borderColor={useColorModeValue('gray.200', 'gray.700')}
        zIndex={1000}>
        <Text fontFamily='impact' fontSize='5xl'>
            I JUST BE ONLINE
        </Text>
      </Flex>
    </HStack>
  )
}

export default AppShell;